import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IRGSGetUrl, IRGSServerResponse } from '../../types/interfaces/Slots/RGS';

import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { getTab } from './utils228';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList({ data }: IConvertGameList<IRGSServerResponse>): ISlotViewItem[] {
    const result: ISlotViewItem[] = [];

    data.game_list
      .filter(g => g.provider.name.toLowerCase().includes('pragmatic'))
      .forEach(game => {
        result.push({
          id: String(game.id),
          gameId: String(game.id),
          gameName: game.name,
          tab: getTab(String(game.id)),
          routeProvider: 'pragmatic-rgs',
          type: CasinoType.slots,
          provider: 'pragmatic-rgs',
          imageUrl: game.iconImageUrl,
          technologyId: String(game.id),
          description: game.name,
          isLiveGame: game.externalData === 'tv',
        });
      });

    return result;
  }

  convertGameUrl = ({ data }: IGetGameUrl<IRGSGetUrl, null>) => data;
}
export default Converter;
